import { ApplicationRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-zoomer',
  templateUrl: './zoomer.component.html',
  styleUrls: ['./zoomer.component.scss']
})
export class ZoomerComponent implements OnInit {

  private _elementRef: ElementRef;
  private _zoomValue: number = 1;

  constructor(
    private _renderer: Renderer2,
    private appRef: ApplicationRef
  ) { }

  ngOnInit() {
    this._elementRef = this.appRef.components[0].injector.get(ElementRef);
  }

  increaseZoom() {
    if (this._zoomValue >= 1.2) return;

    this._zoomValue += .1;
    this._updateUIValue();
  }

  decreaseZoom() {
    if (this._zoomValue <= 1) return;

    this._zoomValue -= .1;
    this._updateUIValue();
  }

  private _updateUIValue() {    
    const element: HTMLElement = this._elementRef.nativeElement;
    this._renderer.setStyle(this._elementRef.nativeElement, 'zoom', `${this._zoomValue}`);
  }
}
